
import { createGlobalState } from 'react-hooks-global-state';

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */



const { setGlobalState, useGlobalState, getGlobalState } = createGlobalState({
    contract: null,
    maxSupply: "",
    connectedAccount: "",
    nfts: [],
    mynfts: [],
    web3: null,
    mode: 0,
    popup: [],
    reflection: 0,
  })
  

function _(x){
    return document.querySelector(x);
}

export function displayPopUp(x){
    _(x).style.transform = "scaleX(1)";
}

export function closePopup(x){
    _(x).style.transform = "scaleX(0)";
}

export function Expandbox( e, id){
    const popup = getGlobalState('nfts').filter((nft) => {
      return id === nft.edition;
    })
    setGlobalState('popup', popup);
    _(e).style.transform = "scaleY(1)";
}

export function Closebox(e){
    _(e).style.transform = "scaleY(0)";
}



export {
  useGlobalState,
  setGlobalState,
  getGlobalState
}

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
